import { createIcon } from '@chakra-ui/icon'

const EOTIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <>
      <path
        d="M68.5 83.5h-59C7 83.5 5 81.5 5 79V8c0-2.5 2-4.5 4.5-4.5h44.4L73 20.7V79c0 2.4-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M68.5 83c2.2 0 4-1.8 4-4V21L53.6 4H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5V8c0-2.8 2.2-5 5-5H54l19.4 17.6V79c.1 2.7-2.2 5-4.9 5z"
        fill="#E1E4EA"
      />
      <path
        d="M73.5 33h-69V8c0-2.8 2.2-5 5-5H55l18.4 17.5V33z"
        fill="#74BB71"
      />
      <path
        d="M55.2 3v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(11.467 21.968)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        EOT
      </text>
      <path
        d="M51.6 42.8H28c-.5 0-1 .4-1 1v5.7c0 .5.4 1 1 1h2.6c.5 0 1-.4 1-1v-1.9s0-.1.1-.1H37.6v22.2s0 .1-.1.1h-1.8c-.5 0-1 .4-1 1v2.6c0 .5.4 1 1 1h8.5c.5 0 1-.4 1-1v-2.6c0-.5-.4-1-1-1h-1.8s-.1 0-.1-.1V47.5s0-.1.1-.1H48s.1 0 .1.1v1.9c0 .5.4 1 1 1h2.6c.5 0 1-.4 1-1v-5.7c-.1-.5-.6-.9-1.1-.9zm.1 6.6c0 .1-.1.1 0 0l-2.7.1s-.1 0-.1-.1v-1.9c0-.5-.4-1-1-1h-5.8c-.5 0-1 .4-1 1v22.2c0 .5.4 1 1 1h1.8s.1 0 .1.1v2.6s0 .1-.1.1h-8.5s-.1 0-.1-.1v-2.6s0-.1.1-.1h1.8c.5 0 1-.4 1-1V47.4c0-.5-.5-.9-1-.9h-5.8c-.5 0-1 .4-1 1v1.9s0 .1-.1.1H28s-.1 0-.1-.1v-5.7s0-.1.1-.1h23.6s.1 0 .1.1v5.7z"
        fill="#E1E4EB"
      />
    </>
  ),
})

export default EOTIcon
